// extracted by mini-css-extract-plugin
module.exports = {"container":"airDropHistoryStyles_container__ZE8Nb","title":"airDropHistoryStyles_title__3YvAP"};